import React from 'react'
import { Link } from 'react-router-dom';
import CustomerOrderDetailsContent from '../../../components/Dashboard/CustomerOrdersListContent/View';

function CustomerOrderDetails() {
    return (
        <>
          {/* Breadcrumb */}
          {/* <div className="breadcrumb-card">
            <h5>Customer Orders List</h5>
    
            <ul className="breadcrumb">
              <li>
                <Link to="/dashboard/ecommerce/">
                  <i className="material-symbols-outlined">home</i>
                  Dashboard
                </Link>
              </li>
              <li>Customer Orders List Details</li>
            </ul>
          </div> */}
           
          <CustomerOrderDetailsContent />
        </>
      );
}

export default CustomerOrderDetails
